import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import StyledTableRow from "../../components/StyledTableRow";
import { countOrACVFormatter } from "../../util/customFunctions";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: "2rem",
  },
  sticky: {
    position: "sticky",
    left: -1,
    background: "white",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "1.5px",
      background: "lightgrey",
    },
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "200px",
    textAlign: "center",
  },
   repCell: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  mainTableContainer: {
    maxHeight: "85vh",
    maxWidth: "90vw",
    border: "0.5px solid lightgrey",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    // borderRadius: "8px",
  },
}));

export default function SplitByTable(props) {
  const classes = useStyle();
  const tableRef = useRef();
  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [rowPin, setRowPin] = useState(false);

  const uniqueCols = [...props.quarters, 'Total'] || [];
  const uniqueTypes = props.uniqueTypes || [];

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    handleOverflowCheck();
    window.addEventListener("resize", handleOverflowCheck);

    return () => window.removeEventListener("resize", handleOverflowCheck);
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      setIsSticky(tableContainer.scrollLeft > 0);
      setRowPin(tableContainer.scrollTop > 0);
    };

    tableContainer.addEventListener("scroll", handleScroll);
    return () => tableContainer.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={classes.root} >
      <Grid container direction="column" alignItems="center">
       
          <div style={{ alignSelf: "flex-end", marginBottom: "10px" }}>
            <CopyTablesObject tableRef={tableRef} />
          </div>
       

        <TableContainer
          ref={tableContainerRef}
          className={classes.mainTableContainer}
        >
          <Table
            ref={tableRef}
            size="small"
            aria-label="data table"
            style={{ tableLayout: "auto", width: "initial" }}
            data-test={props.dataTest}
          >
            <TableHead style={{ position: "sticky", top: -1, zIndex: 5 }}>
              <TableRow>
                <TableCell
                  align="center"
                  className={
                    isSticky
                      ? `${classes.sticky} ${classes.repHeader}`
                      : classes.repHeader
                  }
                  style={{background: 'white'}}
                >
                  {props.firstColumnHeader}
                </TableCell>

                {uniqueCols.map((col, index) => (
                  <TableCell
                    key={col}
                    align="center"
                    className={classes.repHeader}
                    style={{
                      background: index % 2 === 0 ? "#4471c4" : "#5b9bd5",
                      color: "white",
                    }}
                  >
                    {col}
                  </TableCell>
                ))}

                {uniqueCols.length === 0 && (
                  <TableCell
                    className={classes.repHeader}
                    style={{ width: 400, textAlign: "center" }}
                  >
                    No data available
                  </TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
                     <StyledTableRow key={'typehhgfdf'} style={{background: '#dae3f3'}}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                     style={{fontWeight :  600}}
                  >
                    {'Goal Total'}
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col && f[props.type] === 'Total'
                    );
                  let acv = "-";
if (data.length > 0) {
  const value = data[0].goal;
  if (value != null && value !== "") {
    acv = countOrACVFormatter(value, true);
  }
}

                    return (
                      <TableCell
                        key={`${col}-1`}
                        align="right"
                        className={classes.repCell}
                        style={{fontWeight: 600}}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>

              
              {uniqueTypes.map((type) => (
                <StyledTableRow key={type}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                     style={{paddingLeft: '2rem'}}
                  >
                    {type} ({props.percentages.filter(f => f[props.type] === type).reduce((a, b) => a+b.Percentage, 0)}% for {props.percentages.find(f => f[props.type] === type)?.Team || "-"})
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col && f[props.type] === type
                    );
                  let acv = "-";
if (data.length > 0) {
  const value = data[0].goal;
  if (value != null && value !== "") {
    acv = countOrACVFormatter(value, true);
  }
}

                    return (
                      <TableCell
                        key={`${type}-${col}`}
                        align="right"
                        className={classes.repCell}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>
              ))}


                <StyledTableRow key={'typehhgfdf'} style={{background: '#dae3f3'}}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                     style={{fontWeight :  600}}
                  >
                    {'Actual Total'}
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col && f[props.type] === 'Total'
                    );
                  let acv = "-";
if (data.length > 0) {
  const value = data[0].actual;
  if (value != null && value !== "") {
     const a = countOrACVFormatter(value, true);
     const perc = `${countOrACVFormatter(Math.round(data.reduce((a,b) => a+b.perc, 0) * 100))}%`
      acv = `${a} (${perc})`
  }
}
let qtrs = col === 'Total' ? uniqueCols.filter(f => f !== 'Total') : col
let qtr = typeof qtrs === 'string' ? [qtrs] : qtrs.filter(f => f !== 'Total')
                    return (
                      <TableCell
                        key={`${col}-1`}
                        align="right"
                        className={classes.repCell}
                        style={{fontWeight: 600, cursor: 'pointer'}}
                         onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', uniqueTypes, props.type, qtr)}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>

              
              {uniqueTypes.map((type) => (
                <StyledTableRow key={type}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                     style={{paddingLeft: '2rem'}}
                  >
                    {type}
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col && f[props.type] === type
                    );
                  let acv = "-";
if (data.length > 0) {
  const value = data[0].actual;
  if (value != null && value !== "") {
    const a = countOrACVFormatter(value, true);
     const perc = `${countOrACVFormatter(Math.round(data.reduce((a,b) => a+b.perc, 0) * 100))}%`
      acv = `${a} (${perc})`
  }
}
let qtrs = col === 'Total' ? uniqueCols.filter(f => f !== 'Total') : col
let qtr = typeof qtrs === 'string' ? [qtrs] : qtrs.filter(f => f !== 'Total')
const t = typeof type === 'string' ? [type] : type
                    return (
                      <TableCell
                        key={`${type}-${col}`}
                        align="right"
                        className={classes.repCell}
                        style={{cursor: 'pointer'}}
                          onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', t, props.type, qtr)}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>
              ))}


                   <StyledTableRow key={'typehhgfdf'} style={{background: '#dae3f3'}}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                     style={{fontWeight :  600, width: '280px', fontSize: '1.1rem'}}
                  >
                    {'Delta (Under -ve / Over +ve) Total'}
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col && f[props.type] === 'Total'
                    );
                  let acv = "-";
                  let clr = 'black'
if (data.length > 0) {
  const value = data[0].delta;
  if (value != null && value !== "") {
     const a = countOrACVFormatter(value, true);
     const perc = `${countOrACVFormatter(Math.round(data.reduce((a,b) => a+b.deltaPerc, 0) * 100))}%`
      acv = `${a} (${perc})`
  }

  if(value < 0){
    clr= 'red'
}
}



                    return (
                      <TableCell
                        key={`${col}-1`}
                        align="right"
                        className={classes.repCell}
                        style={{fontWeight: 600, color: clr, fontSize: '1.1rem'}}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>

              
              {uniqueTypes.map((type) => (
                <StyledTableRow key={type}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                     style={{paddingLeft: '2rem'}}
                  >
                    {type}
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col && f[props.type] === type
                    );
                  let acv = "-";
                  let clr = 'black'
if (data.length > 0) {
  const value = data[0].delta;
  if (value != null && value !== "") {
    const a = countOrACVFormatter(value, true);
     const perc = `${countOrACVFormatter(Math.round(data.reduce((a,b) => a+b.deltaPerc, 0) * 100))}%`
      acv = `${a} (${perc})`
  }
  if(value < 0){
    clr= 'red'
}
}

                    return (
                      <TableCell
                        key={`${type}-${col}`}
                        align="right"
                        className={classes.repCell}
                        style={{color: clr}}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>
              ))}


            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </div>
  );
}
